export default "__VITE_ASSET__DIKLKkXP__"